module.exports = __webpack_public_path__ + "img/son.249562cc.jpg";